import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { ActionModal } from "@circle-react-shared/ModalsV2/ActionModal";
import { FullScreenModal } from "@circle-react-shared/ModalsV2/FullScreenModal";
import { ModalCloseButton } from "@circle-react-shared/ModalsV2/FullScreenModal/components/ModalCloseButton";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { DefaultFullPreview } from "../../DefaultFullPreview";

interface ModalPreviewComponentProps {
  preview: PaywallCheckoutPreview;
}

const ModalPreviewComponent = ModalManager.create(
  ({ preview }: ModalPreviewComponentProps) => {
    const modal = useModal();
    const onClose = () => {
      void modal.hide();
    };

    const isSmScreen = useSmScreenMediaQuery();

    if (!isSmScreen) {
      return (
        <ActionModal
          title={t("paywall_checkout.order_summary")}
          titleClassName="!text-left !px-0"
          isOpen={modal.visible}
          onClose={onClose}
        >
          <DefaultFullPreview.ModalPreviewTemplate preview={preview} />
        </ActionModal>
      );
    }

    return (
      <FullScreenModal
        isOpen={modal.visible}
        onClose={onClose}
        shouldShowCloseButton
        className="!h-auto !max-h-[80%] rounded-t-2xl"
      >
        <FullScreenModal.Header className="border-none !py-4">
          <div className="flex w-full flex-row items-center justify-between">
            <Typography.TitleMd weight="font-bold">
              {t("paywall_checkout.order_summary")}
            </Typography.TitleMd>
            <ModalCloseButton onClick={onClose} />
          </div>
        </FullScreenModal.Header>
        <FullScreenModal.Body className="px-5">
          <DefaultFullPreview.ModalPreviewTemplate preview={preview} />
        </FullScreenModal.Body>
      </FullScreenModal>
    );
  },
);

export const useModalPreview = () => useModal(ModalPreviewComponent);
